import { render, staticRenderFns } from "./AppSelectDesktop.vue?vue&type=template&id=6d337cbf&scoped=true"
import script from "./AppSelectDesktop.vue?vue&type=script&lang=js"
export * from "./AppSelectDesktop.vue?vue&type=script&lang=js"
import style0 from "./AppSelectDesktop.vue?vue&type=style&index=0&id=6d337cbf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d337cbf",
  null
  
)

export default component.exports